<!--
 * @Author: 刘帅博 liushuaibo@yangxuan.net
 * @Date: 2023-09-08 17:28:28
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-18 11:06:06
 * @FilePath: \partner.chaoyongtuan.com\src\views\cooperationProgress\list\components\cardList\components\buyerRemark.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="pl-16 pr-14 font-h6-regular" style="width: 210px">
		<div class="font-h6-regular yx-color-text-primary" v-if="row.tabName === '3'">
			<p>
				<span>开始合作：</span>
				<span>{{ row.cooperate_start_time | formatEmpty }}</span>
				<i class="yx-color-text-placeholder el-icon-edit-outline ml-4 cursor-pointer hover" @click="editTime()"></i>
			</p>
			<p>
				<span>终止合作：</span>
				<span>{{ row.cooperate_end_time | formatEmpty }}</span>
			</p>
		</div>
		<div v-if="row.url_check_status == linkStatus.tobeCheck">
			<span class="yx-color-info">{{ '待校验链接' }}</span>
		</div>
		<div class="yx-color-text-primary flex-row-align-center" v-if="row.url_check_status == linkStatus.finished && !$isKs(row.platform_id)">
			<span class="flex-shrink">链接：</span>
			<el-tooltip effect="dark" v-ak-tooltip-auto-show :content="row.partner_url" placement="top-start">
				<a class="yx-color-text-primary line-ellipsis-1" style="width: 100%" :href="row.partner_url" target="_blank">{{ row.partner_url || '无' }}</a>
			</el-tooltip>
			<i class="el-icon-copy-document cursor-pointer ml-4 mt-2 hover" v-if="row.partner_url" @click="handleCopy(row.partner_url)"></i>
		</div>
		<template v-if="row.tabName === '2'">
			<div v-if="changeLink">
				<span class="yx-color-primary cursor-pointer" @click="linkBtn('更换链接')">
					更换链接
					<i class="el-icon-arrow-right mt-2"></i>
				</span>
			</div>
			<div v-if="uploadLink">
				<span class="yx-color-primary cursor-pointer" @click="linkBtn('上传链接')">
					上传链接
					<i class="el-icon-arrow-right mt-2"></i>
				</span>
			</div>
			<div v-if="changeLId">
				<span class="yx-color-primary cursor-pointer" @click="linkBtn('更换ID')">
					更换ID
					<i class="el-icon-arrow-right mt-2"></i>
				</span>
			</div>
		</template>
		<div v-if="row.is_sync_work == '1' && row.tabName === '3'">
			<span class="shop-bind-tag radius-4 fz-12">已同步交付视频至商家</span>
		</div>
	</div>
</template>
<script>
import { copy } from '@/utils/common';
import { linkStatus, cooperationStatus } from '@/utils/dataMap';
export default {
	props: {
		row: {
			type: Object,
			default: () => {},
		},
	},
	inject: {
		replaceLinkFun: {
			default: () => {
				return () => {};
			},
		},
		settingBeginTime: {
			default: () => {
				return () => {};
			},
		},
	},
	computed: {
		// isDyPlatform({ row }) {
		// 	return +row.platform_id === +PLATFORM_DY.value;
		// },
		changeLink({ row, linkStatus }) {
			// 链接校验状态为待校验链接
			const isUrlWaitCheck = +row.url_check_status === +linkStatus.tobeCheck;
			// 合作进度已暂停
			const isPauseCooperate = +row.cooperate_status === +cooperationStatus.pause;
			return (
				this.$isPlatOr(row.platform_id, ['Dy', 'Sp']) &&
				isUrlWaitCheck &&
				!isPauseCooperate &&
				this.$auth.hasPermi('system:cooperationProgress:Waiting-switch')
			);
		},
		uploadLink({ row, linkStatus }) {
			return row.url_check_status == linkStatus.toboUp && this.$auth.hasPermi('system:cooperationProgress:upload-link');
		},
		// isKsPlatform({ row }) {
		// 	return +row.platform_id === +PLATFORM_KS.value;
		// },

		changeLId({ row }) {
			// 合作进度已暂停
			const isPauseCooperate = +row.cooperate_status === +cooperationStatus.pause;
			return this.$isKs(row.platform_id) && !isPauseCooperate && this.$auth.hasPermi('system:cooperationProgress:Waiting-switch');
		},
	},
	data() {
		return {
			linkStatus,
		};
	},
	methods: {
		handleCopy(id) {
			copy(id);
			this.$message.success('复制成功');
		},
		linkBtn(title) {
			this.replaceLinkFun(this.row, title);
		},
		editTime() {
			this.settingBeginTime(this.row);
		},
	},
};
</script>
<style lang="less" scoped>
.shop-bind-tag {
	padding: 0 4px;
	display: inline;
	height: 18px;
	line-height: 18px;
	border: 1px solid #cff1d2;
	color: @color-g;
}
</style>
